import React from 'react';
import { Box, Typography } from '@mui/material';

const TermsOfService: React.FC = () => (
  <Box sx={{ p: 3, maxWidth: 800, mx: 'auto', mt: 10 }}>
    <Typography variant="h3" gutterBottom>Terms of Service</Typography>
    <Typography variant="body2" gutterBottom>Last updated: 1 January 2025</Typography>

    <Typography variant="h5" gutterBottom>1. Using Enantio</Typography>
    <Typography paragraph>Enantio is provided for lawful purposes. You agree not to misuse the service or attempt to disrupt it.</Typography>

    <Typography variant="h5" gutterBottom>2. Accounts</Typography>
    <Typography paragraph>You are responsible for the security of your account and for all activity that occurs under it.</Typography>

    <Typography variant="h5" gutterBottom>3. Acceptable Use</Typography>
    <Typography component="div">
      <ul>
        <li>No unlawful, infringing or harmful content.</li>
        <li>No reverse engineering or unauthorized access.</li>
        <li>No use that could interfere with the service or other users.</li>
      </ul>
    </Typography>

    <Typography variant="h5" gutterBottom>4. Termination</Typography>
    <Typography paragraph>We may suspend or terminate access for any breach of these terms. You may stop using the service at any time and request deletion of your data.</Typography>

    <Typography variant="h5" gutterBottom>5. Disclaimer</Typography>
    <Typography paragraph>The service is provided "as is" without warranties. To the extent permitted by law, we are not liable for indirect or consequential damages.</Typography>

    <Typography variant="h5" gutterBottom>6. Governing Law</Typography>
    <Typography paragraph>These terms are governed by the laws of the Netherlands, and any disputes will be resolved in the courts of the Netherlands.</Typography>

    <Typography variant="h5" gutterBottom>7. Changes</Typography>
    <Typography paragraph>We may update these terms occasionally. Continued use of the service constitutes acceptance of the revised terms.</Typography>
  </Box>
);

export default TermsOfService;
